import { Component, computed, inject, signal } from '@angular/core';
import { toSmartAssistantValidationTable } from '../validation-tables/smart-assistant-validation-table.mapper';
import { SmartAssistantImportService } from '../smart-assistant-import.service';

@Component({
    standalone: false,
    selector: 'app-smart-assistant-validation-step',
    templateUrl: './smart-assistant-validation-step.component.html'
})
export class SmartAssistantValidationStepComponent {
    readonly service = inject(SmartAssistantImportService);

    readonly showUnchanged = signal(false);
    readonly tableData = computed(() =>
        toSmartAssistantValidationTable(
            this.service.importType(),
            this.service.validationResult(),
            this.service.importColumns(),
            this.service.columnLabels(),
            this.showUnchanged()
        )
    );
}
